// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ADD_POLICY_WALLET, POLICY_WALLET, POLICY_WALLET_DELETE } from '../../../../../common/constant'
import Api from '../../../../../common/api/multipart';
import { get, post } from '../../../../../common/api';

export const actionAddPolicyWallet = createAsyncThunk('policyWalletStore/actionAddPolicyWallet', async (params) => {
    return await Api.multipart(ADD_POLICY_WALLET, params)
})

export const actionPolicyWallet = createAsyncThunk('policyWalletStore/actionPolicyWallet', async (params, thunkAPI) => {
    return await get(POLICY_WALLET, params)
})

export const actionPolicyWalletDelete = createAsyncThunk('policyWalletStore/actionPolicyWalletDelete', async (params, thunkAPI) => {
    return await post(POLICY_WALLET_DELETE, params)
})

export const policyWalletSlice = createSlice({
    name: 'policyWalletStore',

    initialState: {
        //add policy wallet 
        loadingPolicyWallet: false,
        policyWallet: null,

        //add policy wallet 
        loadingAddPolicyWallet: false,
        addPolicyWallet: null,

        //delete policy wallet 
        loadingDeletePolicyWallet: false,
        deletePolicyWallet: null
    },
    reducers: {
        //reset or delete public store data
        resetAddPolicyWalletResponse: (state) => {
            state.addPolicyWallet = null
        },

        resetPolicyWalletResponse: (state) => {
            state.policyWallet = null
        },

        resetPolicyWalletDeleteResponse: (state) => {
            state.deletePolicyWallet = null
        }
    },
    extraReducers: builder => {
        builder
            //add policy wallet 
            .addCase(actionAddPolicyWallet.pending, (state) => {
                state.loadingAddPolicyWallet = true
            })
            .addCase(actionAddPolicyWallet.fulfilled, (state, action) => {
                state.loadingAddPolicyWallet = false
                state.addPolicyWallet = action.payload
            })
            .addCase(actionAddPolicyWallet.rejected, (state) => {
                state.loadingAddPolicyWallet = false
            })

            //policy wallet 
            .addCase(actionPolicyWallet.pending, (state) => {
                state.loadingPolicyWallet = true
            })
            .addCase(actionPolicyWallet.fulfilled, (state, action) => {
                state.loadingPolicyWallet = false
                state.policyWallet = action.payload
            })
            .addCase(actionPolicyWallet.rejected, (state) => {
                state.loadingPolicyWallet = false
            })

            //policy wallet delete
            .addCase(actionPolicyWalletDelete.pending, (state) => {
                state.loadingDeletePolicyWallet = true
            })
            .addCase(actionPolicyWalletDelete.fulfilled, (state, action) => {
                state.loadingDeletePolicyWallet = false
                state.deletePolicyWallet = action.payload
            })
            .addCase(actionPolicyWalletDelete.rejected, (state) => {
                state.loadingDeletePolicyWallet = false
            })
    }
})
export const { resetAddPolicyWalletResponse, resetPolicyWalletResponse, resetPolicyWalletDeleteResponse } = policyWalletSlice.actions

export default policyWalletSlice.reducer